import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { Stack as o } from "@mui/joy";
import { memo as t } from "react";
import { S as l } from "../../../../../../../index.B-E4PB3F.js";
import a from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import n from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import s from "../../labels/CredentialsLabel/CredentialsLabel.js";
const m = t(({
  syncDirection: r
}) => /* @__PURE__ */ e.jsxs(o, { children: [
  /* @__PURE__ */ e.jsx(n, {}),
  /* @__PURE__ */ e.jsx(a, { label: "Storage account", name: "azure.credentials.storageAccount", placeholder: 'e.g. "myazureaccount"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Storage container", name: "azure.credentials.storageContainer", placeholder: 'e.g. "my-container"' }),
  /* @__PURE__ */ e.jsx(a, { label: "Blob name", name: "azure.credentials.blobName", placeholder: 'e.g. "my-file.csv"' }),
  r === l.IMPORT ? /* @__PURE__ */ e.jsx(a, { label: "Stored dataset name", name: "datasetName", placeholder: 'e.g. "dataset-name"', required: !1 }) : null,
  /* @__PURE__ */ e.jsx(s, {}),
  /* @__PURE__ */ e.jsx(a, { label: "SAS Token", name: "azure.credentials.sasToken", placeholder: 'e.g. "sp=racw&st=2023-08-02T10:27:33Z…"', type: "masked" })
] }));
m.displayName = "AzureFormControls";
export {
  m as default
};
//# sourceMappingURL=AzureFormControls.js.map
